export const getRoleById = (payload: { id: number }) => ({
    type: "@saga/GET_ROLE_BY_ID",
    payload
});